export default __webpack_public_path__ + "static/media/yellow_stroke_cut.b27dae85.png";